import React from 'react'
import './Business.css'
import logo from '../../img/logo.png'
import hardData from '../../img/hard-data.png'
import realSolutions from "../../img/real-solutions.png"
import hardQuestions from "../../img/hard-questions.png"

const Business = (props) => {
  return (
    <section className="business-section" >

        <div className="biz-leaders">
          <img src={logo} className="large-logo" alt="logo"/>
        </div>

        <hr className="hr" />

        <div className="biz-leaders">
          <div className="biz-text">
            <h2>An Alliance of</h2>
            <h1>Mississippi</h1>
            <h3>Business Leaders</h3>
          </div>
        </div>


        <hr className="hr" />


        <div className="biz-leaders">

          <h2 className="center-dark" >Dedicated to</h2>

          <div id="three-points" className="three-points row">

            <div id="hard-questions" className="points hard-questions col-sm-4">
              <h4>Answering</h4>
              <img src={hardQuestions} alt="hard questions"/>
              <h2>Hard</h2>
              <h4>Questions</h4>
            </div>

            <div id="hard-data" className="points hard-data col-sm-4">
              <h4>Wit<span className="last-letter">h</span></h4>
              <img src={hardData} alt="hard data"/>
              <h2>Hard</h2>
              <h4>Dat<span className="last-letter">a</span></h4>
            </div>

            <div id="real-solutions" className="points real-solutions col-sm-4">
              <h4>To For<span className="last-letter">m</span></h4>
              <img src={realSolutions} alt="real solutions"/>
              <h2>Rea<span className="last-letter">l</span></h2>
              <h4>Solutions</h4>
            </div>

          </div>
        </div>

    </section>
  );
}

export default Business



/** WEBPACK FOOTER **
 ** ./src/components/home/Business.js
 **/